<template>
  <button
    class="btn"
    :style="{
      background: disabled ? disabledBg : currentBg,
      color: disabled ? defaultColor : currentColor,
    }"
    :disabled="disabled || loading"
    @click="_click"
  >
    <i class="iconfont icon-shuaxin icon" v-if="loading"></i>
    <slot> 登陆 </slot>
  </button>
</template>

<script>
export default {
  name: "YkButton",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabledBg: {
      type: String,
      default: "#fff",
    },
    defaultColor: {
      type: String,
      default: "#000",
    },
    currentColor: {
      type: String,
      default: "#fff",
    },
    currentBg: {
      type: String,
      default: "#5932ea",
    },
  },
  methods: {
    _click(e) {
      this.$emit("click", e);
    },
  },
};
</script>

<style lang="less" scoped>
.btn {
  width: 100%;
  height: 100%;
  outline: none;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000;
  padding: 1rem;
  background: #fff;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 6px 0px,
    rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
  word-break: keep-all;
  cursor: pointer;
  font: 500 1.286rem/1.92rem "SourceHanSansCN_Bold";
  &:disabled {
    cursor: not-allowed;
  }
  .icon {
    animation: rotate 1s linear infinite;
    transform-origin: 100%, 100%;
    font-size: large;
  }
}
@keyframes rotate {
  0% {
    transform: rotate(0);
    transform-origin: center, center;
  }
  100% {
    transform-origin: 100%, 100%;
    transform: rotate(360deg);
  }
}
</style>